import { render, staticRenderFns } from "./ChannelGrid.vue?vue&type=template&id=302118ee&scoped=true"
import script from "./ChannelGrid.vue?vue&type=script&lang=js"
export * from "./ChannelGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302118ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('302118ee')) {
      api.createRecord('302118ee', component.options)
    } else {
      api.reload('302118ee', component.options)
    }
    module.hot.accept("./ChannelGrid.vue?vue&type=template&id=302118ee&scoped=true", function () {
      api.rerender('302118ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ChannelGrid.vue"
export default component.exports